import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-16 flex mb-5 font-size-18" }
const _hoisted_2 = { class: "w-40 text-right mr-10" }
const _hoisted_3 = { class: "flex mb-16 font-size-18" }
const _hoisted_4 = { class: "w-40 text-right mr-10" }
const _hoisted_5 = { class: "mb-2 font-bold" }
const _hoisted_6 = { class: "text-red-ff" }
const _hoisted_7 = { class: "flex justify-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "px-2" }, "~", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('affiliationDepartment')), 1),
      _createVNode("div", null, _toDisplayString(_ctx.myAccount.unit_name), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('fullName')), 1),
      _createVNode("div", null, _toDisplayString(_ctx.myAccount.employee_name), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('shiftsRequestedToBeSubmitted')), 1),
      _createVNode(_component_Table, {
        class: "text-center font-bold",
        headers: _ctx.submitDesiredHeaders,
        data: _ctx.shiftPlanRequestData,
        showPagination: true,
        loading: _ctx.loading,
        "selected-item": _ctx.shiftPlanRequestSelected,
        "onUpdate:selected-item": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shiftPlanRequestSelected = $event)),
        recordTotal: _ctx.pagination.total,
        currentPage: _ctx.paramsShiftPlan.page,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paramsShiftPlan.page = $event)),
        itemsPerPages: _ctx.pagination.per_page,
        onOnChangePage: _ctx.onChangePage
      }, {
        deadline: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.displayDateFormat(item.deadline, 'YYYY/MM/DD (dddd)')), 1)
        ]),
        shift_notification_status_date: _withCtx(({ item }) => [
          _createVNode("div", null, _toDisplayString(_ctx.displayDateFormat(
                item.shift_notification_status_date,
                'YYYY/MM/DD (dddd)'
              )), 1)
        ]),
        shift_plan_name: _withCtx(({ item }) => [
          _createVNode("div", null, _toDisplayString(item.shift_plan_name), 1)
        ]),
        shift_plan_status: _withCtx(({ item }) => [
          _createVNode("div", null, _toDisplayString(_ctx.defineStatusShiftPlan(item.shift_plan_status.toString())), 1)
        ]),
        start_end_date: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", null, _toDisplayString(_ctx.displayDateFormat(
                  item.shift_register_start_date,
                  'YYYY/MM/DD (dddd)'
                )), 1),
            _hoisted_8,
            _createVNode("div", null, _toDisplayString(_ctx.displayDateFormat(
                  item.shift_register_end_date,
                  'YYYY/MM/DD (dddd)'
                )), 1)
          ])
        ]),
        desired_shift_input: _withCtx(({ item }) => [
          _createVNode(_component_Button, {
            class: [{ 'btn-disabled-shift': _ctx.isDisableShiftButton }, "btn-gradation-light-blue font-size-14 font-bold"],
            disabled: _ctx.isDisableShiftButton,
            onClick: ($event: any) => (_ctx.goToEnterTheDesiredShift(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('enterTheDesiredShift')), 1)
            ]),
            _: 2
          }, 1032, ["class", "disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["headers", "data", "loading", "selected-item", "recordTotal", "currentPage", "itemsPerPages", "onOnChangePage"])
    ])
  ]))
}